const columnTypeEnum = {
    /** Colonnes de type dimension : à afficher en premier, sans header de group ni donnée de somme ou moyenne */
    DIMENSION: "dimension",
    /** Colonnes de type mesure : leur key peut contenir une groupKey pour les afficher sous le header de group correspondant */
    MEASURE: "measure",
    /** Colonnes de type groupe : elles contiennent les colonnes de type mesure, avec un header supplémentaire */
    GROUP: "GROUP"
};

const groupKeyEnum = {
    /** Hidden groups : pour les requêtes qui servent uniquement à faire des calculs */
    HIDDENGROUP_TOTALREVENUE: "hiddenGroup.totalRevenue",
    HIDDENGROUP_PERIOD1: "hiddenGroup.period1",
    HIDDENGROUP_PERIOD2: "hiddenGroup.period2",
    HIDDENGROUP_OMNIPLAYEVENT_TOTAL: "hiddenGroup.OmniplayEventTotal",
    HIDDENGROUP_OMNIPLAYEVENT_DETAIL: "hiddenGroup.OmniplayEventDetail",
    HIDDENGROUP_TOKEN_DIFFERENCE: "hiddenGroup.TokenDifference",

    /** Groupes qui seront affichés, il faut donc prévoir le libellé correspondant */
    GROUP_GAMES: "group.games",
    GROUP_SNACK: "group.snack", // sera concaténé avec le type (SnackProduct.type - nombre) pour séparer les snacks du merchandising
    GROUP_REVENUE: "group.revenue",
    GROUP_PAYING_TOKENS: "group.payingTokens",
    GROUP_KIOSK_REVENUE: "group.kioskRevenue",
    GROUP_DIFFERENCE: "group.difference",
    GROUP_RUNNINGTOTALS_DIFFERENCE: "group.runningTotalsDifference",
    GROUP_EXCEPTIONAL: "group.exceptional",
    GROUP_EVENTS: "group.events",
};

const calculatedColumnsEnum = {
    HOUR_PERIOD: "calculatedColumn.hourPeriod",
    PERCENT_PER_ACTIVITY_SNACK: "calculatedColumn.percentPerActivitySnack0",
    PERCENT_PER_ACTIVITY_MERCHANDISING: "calculatedColumn.percentPerActivitySnack1",
    PERCENT_PER_ACTIVITY_GAME: "calculatedColumn.percentPerActivityGame",
    PERCENT_PER_ACTIVITY: "calculatedColumn.percentPerActivity",
    TOTAL_REVENUE_PERCENT_SITE: "calculatedColumn.totalRevenuePercentSite",
    PERCENT_TOTAL_CB: "calculatedColumn.percentCb",
    PERCENT_TOTAL_CASH: "calculatedColumn.percentCash",
    TOKEN_QUANTITY: "calculatedColumn.tokenQuantity",
    TOKEN_QUANTITY_SPENT: "calculatedColumn.tokenQuantitySpent",
    BONUS_TOKEN_QUANTITY: "calculatedColumn.bonusTokenQuantity",
    TAXES_PERCENTAGE: "calculatedColumn.taxesPercentage",
    REVENUE_HT: "calculatedColumn.revenueHt",
    REVENUE_TVA: "calculatedColumn.revenueTva",
    REVENUE_HT_LONG: "calculatedColumn.revenueHtLong",
    REVENUE_TTC: "calculatedColumn.revenueTtc",
    REVENUE_TTC_LONG: "calculatedColumn.revenueTtcLong",
    REVENUE_EQUIVALENT_HT: "calculatedColumn.revenueEquivalentHt",
    REVENUE_EQUIVALENT_TTC: "calculatedColumn.revenueEquivalentTtc",
    SALE_CATEGORY: "calculatedColumn.saleCategory",
    STAFF_CREDITED_TOKENS: "calculatedColumn.staffCreditedTokens",
    TOTAL_DATA: "calculatedColumn.totalData",
    TOTAL_DATA_HT: "calculatedColumn.totalDataHt",
    TOTAL_DATA_TTC: "calculatedColumn.totalDataTtc",
    TOTAL_DATA_TAXES: "calculatedColumn.totalDataTaxes",
    TOTAL_COLUMN: "calculatedColumn.totalColumn",
    TOTAL: "calculatedColumn.total",
    INVOICE_AMOUNT_PERIOD1: "calculatedColumn.invoiceAmountPeriod1",
    INVOICE_AMOUNT_PERIOD2: "calculatedColumn.invoiceAmountPeriod2",
    INVOICE_AMOUNT_HT_PERIOD1: "calculatedColumn.invoiceAmountHtPeriod1",
    INVOICE_AMOUNT_HT_PERIOD2: "calculatedColumn.invoiceAmountHtPeriod2",
    COMPARE_INVOICE_AMOUNTS: "calculatedColumn.compareInvoiceAmounts",
    COMPARE_INVOICE_AMOUNTS_HT: "calculatedColumn.compareInvoiceAmountsHt",
    COMPARE_REVENUE_PERCENT: "calculatedColumn.compareRevenuePercent",
    PERCENT_PER_KIOSK_PERIOD1: "calculatedColumn.percentPerKioskPeriod1",
    PERCENT_PER_KIOSK_PERIOD2: "calculatedColumn.percentPerKioskPeriod2",
    PERCENT_PER_GAME_PERIOD1: "calculatedColumn.percentPerGamePeriod1",
    PERCENT_PER_GAME_PERIOD2: "calculatedColumn.percentPerGamePeriod2",
    PERCENT_PER_OPERATION_PERIOD1: "calculatedColumn.percentPerOperationPeriod1",
    PERCENT_PER_OPERATION_PERIOD2: "calculatedColumn.percentPerOperationPeriod2",
    PERCENT_REVENUE_PER_GAME: "calculatedColumn.percentRevenuePerGame",
    PERCENT_TOKENS_PER_GAME: "calculatedColumn.percentTokensPerGame",
    PERCENT_REVENUE_PER_SNACK: "calculatedColumn.percentRevenuePerSnack",
    PERCENT_TOKEN: "calculatedColumn.percentToken",
    PERCENT_BONUS_TOKEN: "calculatedColumn.percentBonusToken",

    LABEL: "calculatedColumn.label",
    CARDS: "calculatedColumn.cards",
    TOTAL_EURO: "calculatedColumn.totalEuro",
    OTHER_PRODUCTS: "calculatedColumn.otherProducts",
    AVERAGE_BASKET: "calculatedColumn.averageBasket",
    DAILY_REFILL: "calculatedColumn.dailyRefill",
    OLD_REFILL: "calculatedColumn.oldRefill",
    REFILL_NO_DETAIL: "calculatedColumn.refillNoDetail",
    CARDS_SOLD: "calculatedColumn.cardsSold",
    ONLINE_BOOKING: "calculatedColumn.onlineBooking",
    TRANSACTION_NUMBER: "calculatedColumn.transactionNumber",
    PERCENT_PRODUCT: "calculatedColumn.percentProduct",
    RECYCLED: "calculatedColumn.recycled",
    QR_CODE: "calculatedColumn.qrCode",
    TOTAL_CONSUMED: "calculatedColumn.totalConsumed",
    MONETARY: "calculatedColumn.monetary",
    PERCENT_TOTAL_VALUE: "calculatedColumn.percentTotalValue",
    PERCENT_DAILY_REFILL: "calculatedColumn.percentDailyRefill",
    PERCENT_OLD_REFILL: "calculatedColumn.percentOldRefill",
    PERCENT_REFILL_NO_DETAIL: "calculatedColumn.percentRefillNoDetail",
    PERCENT_CARDS_SOLD: "calculatedColumn.percentCardsSold",
    PERCENT_ONLINE_BOOKING: "calculatedColumn.percentOnlineBooking",

    CONTRACT: "calculatedColumn.Contract",

    ONLINE_BOOKING_CARDS: "calculatedColumn.onlineBookingCards",
    ONLINE_BOOKING_CARDS_PERCENT: "calculatedColumn.onlineBookingCardsPercents",
    DISPLAY_EMPTY_COLUMN_EXPIRED: "calculatedColumn.displayEmptyColumnExpired",
    DISPLAY_EMPTY_COLUMN_EXTRA: "calculatedColumn.displayEmptyColumnExtra",
    DISPLAY_EMPTY_COLUMN_GAMES: "calculatedColumn.displayEmptyColumnGames",
    DISPLAY_EMPTY_COLUMN_SNACK: "calculatedColumn.displayEmptyColumnSnack",
    DISPLAY_EMPTY_COLUMN_MERCH: "calculatedColumn.displayEmptyColumnMerch",
    DISPLAY_EMPTY_COLUMN_OMNIPLAY: "calculatedColumn.displayEmptyColumnOmniplay",
    EXTRA_REVENUE_DYNAMIC_TAXES: "calculatedColumn.extraRevenueDynamicTaxes",
    GAME_REVENUE_DYNAMIC_TAXES: "calculatedColumn.gameRevenueDynamicTaxes",
    OMNIPLAY_REVENUE_DYNAMIC_TAXES: "calculatedColumn.omniplayRevenueDynamicTaxes",
    IS_OMNIPLAY_EVENT: "calculatedColumn.isOmniplayEvent",
    SNACK_REVENUE_DYNAMIC_TAXES: "calculatedColumn.snackRevenueDynamicTaxes",
    DATE: "calculatedColumn.date",
    TOKEN_DIFFERENCE: "calculatedColumn.tokenDifference",
    TTC_DIFFERENCE: "calculatedColumn.ttcDifference",
    TOTAL_DYNAMIC_TAXES: "calculatedColumn.totalDynamicTaxes",
    RANK: "calculatedColumn.rank",
    POPULARITY: "calculatedColumn.popularity",
    DIFF_PAYING_TOKENS: "calculatedColumn.diffPayingTokens",
    DIFF_BONUS_TOKENS: "calculatedColumn.diffBonusTokens",
    DIFF_ALL_TOKENS: "calculatedColumn.diffAllTokens",
    DIFF_REVENUE: "calculatedColumn.diffRevenue",
    RUNNINGTOTALS_SPENT_TOKENS: "calculatedColumn.runningTotalsSpentTokens",
    RUNNINGTOTALS_SPENT_AMOUNT: "calculatedColumn.runningTotalsSpentAmount",
    RUNNINGTOTALS_PURCHASED_TOKENS: "calculatedColumn.runningTotalsPurchasedTokens",
    RUNNINGTOTALS_PURCHASED_AMOUNT: "calculatedColumn.runningTotalsPurchasedAmount",
    RUNNINGTOTALS_TOKEN_DIFFERENCE: "calculatedColumn.runningTotalsTokenDifference",
    RUNNINGTOTALS_TTC_DIFFERENCE: "calculatedColumn.runningTotalsTtcDifference",
    RECEIPTS_TOTAL_AMOUNT: "calculatedColumn.receiptsTotalAmount",
    BONUS_TOKENS_RATIO: "calculatedColumn.bonusTokensRatio",
    PERCENT_TOKEN_NOT_CONSUMED: "calculatedColumn.percentTokenNotConsumed",

    TOTAL_REVENUE_5: "calculatedColumn.percentFiftyPointFifty",
    PERCENT_TOTAL_REVENUE_5: "calculatedColumn.percentTotalRevenueFiftyPointFifty",
    TOTAL_REVENUE_10: "calculatedColumn.percentTen",
    PERCENT_TOTAL_REVENUE_10: "calculatedColumn.percentTotalRevenueTen",
    TOTAL_REVENUE_20: "calculatedColumn.percentTwenty",
    PERCENT_TOTAL_REVENUE_20: "calculatedColumn.percentTotalRevenueTwenty",
    NOT_SPENT: "calculatedColumn.notSpent",

    EXPIRED_TOKENS: "calculatedColumn.expiredTokens",
    REMAINING_TOKENS: "calculatedColumn.remainingTokens"
};

const alternativeColumnLabelEnum = {
    PURCHASEHISTORY_TOKEN: "PurchaseHistory.tokenAccountingLbl",
    PURCHASEHISTORY_TOKEN2: "PurchaseHistory.tokenGamesSimpleLbl",
    PURCHASEHISTORY_BONUSTOKEN: "PurchaseHistory.bonustokenGamesSimpleLbl",
    PURCHASEHISTORY_AMOUNT_CASH: "PurchaseHistory.amountMixAccountingLbl0",
    PURCHASEHISTORY_AMOUNT_CB: "PurchaseHistory.amountMixAccountingLbl1",
    PURCHASEHISTORY_AMOUNT_CBDIRECT: "PurchaseHistory.amountTotalAccountingLbl-1",
    PURCHASEHISTORY_AMOUNT_TOTAL: "PurchaseHistory.amountTotalAccountingLbl",
    PURCHASEHISTORY_AMOUNT2: "PurchaseHistory.amountGamesSimpleLbl",
    GAMEHISTORY_TOKEN: "GameHistory.tokenGamesLbl",
    GAMEHISTORY_TOKEN_PRICE: "GameHistory.tokenPriceGamesSimpleLbl",
    GAMEHISTORY_TOKEN_PRICE_HT: "GameHistory.tokenPriceGamesSimpleHtLbl",
    SNACKHISTORY_AMOUNT_CB_TTC: "SnackHistory.amountCbTtcKioskLbl",
    SNACKHISTORY_AMOUNT_CB_TTC2: "SnackHistory.amountCbTtcSnackLbl",
    PURGEHISTORY_TOKEN: "PurgeHistory.BalanceTokensLbl"
};

export { columnTypeEnum };
export { groupKeyEnum };
export { calculatedColumnsEnum };
export { alternativeColumnLabelEnum };
